import { FormInstance, App, Upload } from "antd";
import * as dc from "@/components/layout/list/defaultType";
import { DataColumnField, DataColumnRecord, DataInputCommonParams, TimeLineProps } from "../input/inputType";
import { RefObject } from "react";
import { focusFormField, getInputValueCheck, getInputValuesCheck, runFormFunction, setFormClass } from "../input/inputFunction";
import { Debug } from "@/util/debug";
import dayjs from "dayjs";
import { checkEmpty, getJsonFromStr, getStrFromJson } from "@/util/stringutil";
import { TransitionType } from "../layoutType";
import { convertProfiletoForm, logTempInputCheck } from "@/util/roastingutil";
import { enLocale, koLocale } from "@/i18n/routing";
import { MessageInstance } from "antd/es/message/interface";
import { getIntArray } from "@/util/arrayutil";
import { scrollToDataPosition } from "../data/data";
import { getTimelineShowTimeObject, timelineChartChange } from "../input/timelineChart";
import { getSummaryValues } from "../data/list/list";
import { DefaultOptionType } from "antd/es/select";
import { extractPastProfile, PastProfile } from "@/util/roasting/prediction/knn/pastProfileTypes";
import { getRoastingSeries, getRoastingSeriesCalcLossRatio, getRoastingSeriesInput } from "@/util/roasting/input/roastingSeriesParser";
import { predictRealtimeDrop, PredictRealtimeDropResult } from "@/util/roasting/api/realtimePredictor";
import { RoastingSeries } from "@/util/roasting/input/roastingSeriesTypes";
// import dynamic from "next/dynamic";
// const Upload = dynamic(() => import("antd").then((mod) => mod.Upload), { ssr: false });
const utcOffset = dayjs().utcOffset() * 60000;

export const RoastingCheckCount = 30;

export const roastingIndexKeyStr = "roasting_start_time";
export const roastingTimerList = [
  "pre_heating_start_time",
  "pre_heating_end_time",
  "roasting_first_start_time",
  "roasting_second_start_time",
];
const fixedShowTimeArr = [
  "pre_heating_start",
  "pre_heating_end",
  "roasting_start",
  "roasting_turning",
  "roasting_dried",
  "roasting_first_start",
  "roasting_first_end",
  "roasting_second_start",
  "roasting_second_end",
  "roasting_end",
];
const checkFields = ["_term", "_bean", "_air", "_input1", "_input2", "_input3"];

export const getLastCheckIndex = (form: FormInstance<any> | undefined) => {
  let index = 1;
  if (form) {
    const getFields: string[] = [];
    for (let i = 1; i <= RoastingCheckCount; i++) {
      checkFields.forEach((field) => getFields.push("roasting_check" + i + field));
    }
    const getValues = form.getFieldsValue(getFields);
    for (let i = RoastingCheckCount; i >= 1; i--) {
      if (checkFields.some((field) => getValues["roasting_check" + i + field] !== undefined)) {
        index = i + 1;
        break;
      }
    }
  }
  return index;
};

export const getRoastingShowTimeCheck = (start: number, count: number): Record<string, Record<string, string>> => {
  const result: Record<string, Record<string, string>> = {};
  const series = ["bean", "air"];
  fixedShowTimeArr.forEach((str) => {
    result[str + (str === "roasting_start" ? "_time" : "_term")] = getTimelineShowTimeObject(series, str);
  });
  getIntArray(count, start).forEach((i) => {
    const key = "roasting_check" + i;
    result[key + "_term"] = getTimelineShowTimeObject(series, key);
  });
  // Debug("getRoastingShowTimeCheck", result);
  return result;
};

const roasting_step_str = "roasting_step";
const roastingProfileNextHidden = dc.roastingProfileClassName + " next-hidden";
const clock_list = [
  "roasting_turning",
  "roasting_dried",
  "roasting_first_start",
  "roasting_first_end",
  "roasting_second_start",
  "roasting_second_end",
  // "roasting_end",
];

const roastingTimerStart = (
  form: FormInstance<any> | undefined,
  formFunction: Record<string, Record<string, Function>> | undefined,
  e: any,
  roasting_start_time: boolean,
  setTimer: Function | undefined,
) => {
  const setValues: Record<string, any> = {};
  if (setTimer) {
    const end = form ? (form.getFieldValue("roasting_end_term") ? true : false) : false;

    if (e.value && Math.abs(dayjs().diff(e.value)) < 3600000 && (!end || roasting_start_time)) {
      // "RSRV","RD","PRGRSS","CMPLT","DSPS","CNCL"
      if (form && !checkEmpty(form.getFieldValue(roasting_step_str)) && ["RSRV", "RD"].includes(form.getFieldValue(roasting_step_str))) {
        setValues[roasting_step_str] = "PRGRSS";
      }
      setTimer({ timer: roastingTimerList, start: undefined });
      setTimer({
        timer: roastingIndexKeyStr,
        start: e.value,
        form: { form: form, chart: "timeline_chart", formFunction: formFunction },
      });
    } else {
      setTimer({ timer: [roastingIndexKeyStr, ...roastingTimerList], start: undefined });
    }
  }
  timelineChartChange(form, e);
  if (form) {
    if (e.value !== undefined) {
      setValues.roasting_result_year = e.value;
      setValues.roasting_result_date = e.value;
    }
  }
  if (roasting_start_time) {
    setValues.roasting_start_time = e.value;
  }
  if (Object.keys(setValues).length > 0) {
    form?.setFieldsValue(setValues);
  }
};
const roastingTimerStop = (
  form: FormInstance<any> | undefined,
  formFunction: Record<string, Record<string, Function>> | undefined,
  e: any,
  roasting_end_term: boolean,
  setTimer: Function | undefined,
) => {
  if (setTimer) {
    const setValues: Record<string, any> = {};
    if (e.value) {
      // "RSRV","RD","PRGRSS","CMPLT","DSPS","CNCL"
      if (
        form &&
        !checkEmpty(form.getFieldValue(roasting_step_str)) &&
        ["RSRV", "RD", "PRGRSS"].includes(form.getFieldValue(roasting_step_str)) &&
        !roasting_end_term
      ) {
        setValues[roasting_step_str] = "CMPLT";
      }
      setTimer({ timer: roastingIndexKeyStr, start: undefined, chartTimerClear: true });
      setTimer({ timer: roastingTimerList, start: undefined });
    } else {
      if (form && !roasting_end_term) {
        const start = form.getFieldValue(roastingIndexKeyStr);
        if (start && Math.abs(dayjs().diff(start)) < 3600000) {
          setTimer({
            timer: roastingIndexKeyStr,
            start: start,
            form: { form: form, chart: "timeline_chart", formFunction: formFunction },
          });
          runFormFunction(formFunction, "roasting_end_term", "setNow", undefined);
        }
      }
    }
    if (Object.keys(setValues).length > 0) {
      form?.setFieldsValue(setValues);
    }
  }
};

export const getPrevTerm = (str?: string, newLine?: boolean | string) => {
  return {
    ...dc.timer,
    unitPrev: " : ",
    prev: str ? { element: str, transition: true } : undefined,
    prevNewLine: newLine,
  };
};
export const getPrevTemp = (str?: string, newLine?: boolean | string) => {
  return {
    ...dc.roastingTemp,
    unitPrev: str ? " : " : " / ",
    prev: str ? { element: str, transition: true } : undefined,
    prevNewLine: newLine,
  };
};
export const fillCheckValues = (form: FormInstance<any> | undefined, force?: boolean) => {
  if (form) {
    const checkValues = form.getFieldsValue(["roasting_check_until", "roasting_check_term"]);
    // Debug(checkValues);
    if (force || (checkValues.roasting_check_until !== undefined && checkValues.roasting_check_term !== undefined)) {
      const setValues: Record<string, any> = {};
      const time_until = (checkValues.roasting_check_until ?? 12) * 60;
      const time_term = checkValues.roasting_check_term ?? 60;
      if (checkValues.roasting_check_until === undefined) {
        setValues.roasting_check_until = 12;
      }
      if (checkValues.roasting_check_term === undefined) {
        setValues.roasting_check_term = 60;
      }
      let check_time = 0;
      for (let i = 1; i <= RoastingCheckCount; i++) {
        check_time += time_term;
        if (time_until < check_time) {
          break;
        }
        setValues["roasting_check" + i + "_term"] = dayjs(check_time * 1000).add(-utcOffset);
      }
      form.setFieldsValue(setValues);
    }
  }
};

export const updateCompareProfile = (
  form: FormInstance<any> | undefined,
  formFunction: Record<string, Record<string, Function>> | undefined,
  formMemo: Record<string, any> | undefined,
  dataFunction: Record<string, Function> | undefined,
  locale: string | undefined,
  dataId: string,
  title: string | undefined,
  data: any,
  org?: any,
  diff?: any,
  compare?: any,
  memo?: any,
) => {
  const roasting_name = getInputValueCheck(
    form,
    formMemo,
    dataFunction,
    undefined,
    locale === enLocale ? "roasting_name" : "roasting_name_locale",
  );
  const checkTitle =
    data === undefined || data.roasting_name !== roasting_name
      ? title
      : getSummaryValues(
          undefined,
          {
            field: "roasting_check",
            fieldId: {
              roasting_result_date: {},
              roasting_batch_no: {},
              roasting_loss: dc.lossRate,
            },
            valueJoin: " - ",
          },
          undefined,
          data,
          locale,
          true,
        );

  Debug("updateCompareProfile : ", dataId, checkTitle, roasting_name, data, compare, diff, memo);
  if (formMemo && !formMemo["timeline_chart"]) {
    formMemo["timeline_chart"] = {};
  }
  let emptyData = false;
  if (formMemo && formMemo["timeline_chart"]) {
    if (data) {
      const roastingSeries = getRoastingSeries(data, dataId);
      const pastProfile = extractPastProfile(roastingSeries);
      const cals = getRoastingSeriesCalcLossRatio(roastingSeries);
      if (!formMemo["timeline_chart"].tempData) {
        formMemo["timeline_chart"].tempData = {};
      }
      formMemo["timeline_chart"].tempData[dataId] = {
        title: checkTitle,
        data,
        roastingSeries,
        pastProfile,
        cals,
        compare: true,
      };
    } else {
      const tempData = formMemo["timeline_chart"].tempData;
      if (tempData) {
        Debug(tempData);
        if (tempData[dataId]) {
          delete tempData[dataId];
        }
        if (Object.keys(tempData).length === 0) {
          formMemo["timeline_chart"].tempData = undefined;
          emptyData = true;
        }
      }
    }
  }
  const compareList: string[] = [];
  const calsList: string[] = [];
  const valueList: DefaultOptionType[] | undefined =
    formMemo && formMemo["timeline_chart"] && formMemo["timeline_chart"].tempData
      ? Object.keys(formMemo["timeline_chart"].tempData).map((id) => {
          if (formMemo["timeline_chart"].tempData[id].compare) {
            compareList.push(id);
          }
          if (formMemo["timeline_chart"].tempData[id].cals) {
            const calsStr = Object.keys(formMemo["timeline_chart"].tempData[id].cals)
              .map((key) => key + " : " + formMemo["timeline_chart"].tempData[id].cals[key])
              .join(", ");
            // calsList.push(calsStr);
          }
          return { value: id, label: formMemo["timeline_chart"].tempData[id].title };
        })
      : [];
  const nowId = form?.getFieldValue("roasting_compare_select");
  const setId = data
    ? dataId
    : valueList.length > 0
      ? valueList.map((item) => item.value).includes(nowId)
        ? nowId
        : valueList[valueList.length - 1].value
      : undefined;
  runFormFunction(formFunction, ["roasting_compare_select", "roasting_compare_chart"], "setValueList", valueList);
  // if (nowId !== setId) {
  //   form?.setFieldValue("roasting_compare_select", setId);
  // }

  const { result } = runFormFunction(formFunction, "timeline_chart", "getFixed");
  if (!(result ?? false)) {
    const el = (document.querySelector("form.ant-form .rt-Flex.data-chart.TimelineChart") as HTMLElement)?.parentElement; //?.parentElement
    if (el) {
      scrollToDataPosition(undefined, undefined, el);
    }
  }
  if (org) {
    runFormFunction(formFunction, "roasting_summary", "setValue", org);
  }
  if (compare || (!compare && nowId !== setId)) {
    runFormFunction(
      formFunction,
      "roasting_compare_summary",
      "setValue",
      !checkEmpty(calsList) ? (compare ? compare + "\r\n\r\n" : "") + calsList.join("\r\n") : compare,
    );
  }
  if (diff || (!diff && nowId !== setId)) {
    runFormFunction(formFunction, "roasting_compare_diff", "setValue", diff);
  }
  runFormFunction(formFunction, "timeline_chart", "setCompare", !checkEmpty(setId));

  setTimeout(() => {
    const setValues: Record<string, any> = {
      timeline_chart: true,
      roasting_compare_show: setId,
      roasting_compare_chart: compareList,
    };
    if (nowId !== setId) {
      setValues["roasting_compare_select"] = setId;
    }
    if (memo || (!memo && nowId !== setId) || !checkEmpty(calsList)) {
      setValues["roasting_compare_memo"] = memo;
    }
    form?.setFieldsValue(setValues);
    setFormClass(dataFunction, { compare_item_use: !checkEmpty(setId) });
  }, dc.setTimeoutShort);
};

export const roastingSummaryFieldId = (newLine?: boolean | string): Record<string, DataInputCommonParams> => {
  return {
    roasting_turning_term: getPrevTerm("roasting_turning_term"),
    roasting_turning_bean: getPrevTemp(undefined),
    roasting_dried_term: getPrevTerm("roasting_dried_term", newLine),
    roasting_dried_bean: getPrevTemp(undefined),
    roasting_first_start_term: getPrevTerm("roasting_first_start_term", newLine),
    roasting_first_start_bean: getPrevTemp(undefined),
    roasting_first_end_term: getPrevTerm("roasting_first_end_term", newLine),
    roasting_first_end_bean: getPrevTemp(undefined),
    roasting_second_start_term: getPrevTerm("roasting_second_start_term", newLine),
    roasting_second_start_bean: getPrevTemp(undefined),
    roasting_second_end_term: getPrevTerm("roasting_second_end_term", newLine),
    roasting_second_end_bean: getPrevTemp(undefined),
    roasting_end_term: getPrevTerm("roasting_end_term", newLine),
    roasting_end_bean: getPrevTemp(undefined),
  };
};
export const roastingSummaryFieldIdExp = (newLine?: boolean | string): Record<string, DataInputCommonParams> => {
  return {
    ...roastingSummaryFieldId(newLine),
    roasting_loss: {
      ...dc.lossRate,
      prev: { element: "loss_rate", transition: true },
      unitPrev: " : ",
      prevNewLine: newLine,
    },
    roasting_end_first_term: {
      ...dc.timer,
      prev: "DT : ",
      calcValueProp: { input1: "roasting_end_term", mode: "-", input2: "roasting_first_start_term" },
      prevNewLine: " / ",
    },
    roasting_end_first_ratio: {
      ...dc.percent,
      scale: 1,
      prev: "(",
      calcValueProp: { input1: "roasting_end_term", mode: "dtr", input2: "roasting_first_start_term", fixed: 1 },
      next: ")",
    },
    roasting_mass: { ...dc.mass, prev: { element: "mass", transition: true }, unitPrev: " : ", prevNewLine: " / " },
    // roasting_end_dried_calc1: {
    //   ...dc.number,
    //   calcValueProp: {
    //     input1: {
    //       input1: {
    //         input1: { input1: "roasting_end_term", mode: "-", input2: "roasting_dried_term" },
    //         mode: "*",
    //         input2: { input1: "roasting_end_bean", mode: "-", input2: "roasting_dried_bean" },
    //       },
    //       mode: "/",
    //       input2: 10000,
    //     },
    //     mode: "/",
    //     input2: { input1: 1000, mode: "-", input2: "roasting_loss" },
    //     fixed: 2,
    //   },
    //   prev: "EDTL : ",
    //   prevNewLine: newLine,
    // },
    // roasting_end_dried_calc2: {
    //   ...dc.number,
    //   calcValueProp: {
    //     input1: {
    //       input1: {
    //         input1: { input1: "roasting_end_term", mode: "-", input2: "roasting_dried_term" },
    //         mode: "*",
    //         input2: { input1: "roasting_end_bean", mode: "-", input2: "roasting_dried_bean" },
    //       },
    //       mode: "/",
    //       input2: 10000000000,
    //     },
    //     mode: "*",
    //     input2: { input1: 1000, mode: "-", input2: "roasting_loss" },
    //     fixed: 2,
    //   },
    //   prevNewLine: " / ",
    // },
    // roasting_loss_cals_ratio: {
    //   ...dc.number,
    //   calcValueProp: (values) => {
    //     const calc = getRoastingSeriesCalcLossRatio(getRoastingSeries(values)) as Record<string, number>;
    //     return Object.keys(calc)
    //       .map((key) => key + " : " + calc[key])
    //       .join(", ");
    //   },
    //   prevNewLine: " / ",
    // },
  };
};

export const summaryRefresh = (
  t: TransitionType | undefined,
  form: FormInstance<any> | undefined,
  formFunction: Record<string, Record<string, Function>> | undefined,
  formMemo: Record<string, any> | undefined,
  dataFunction: Record<string, Function> | undefined,
  locale: string | undefined,
  id?: string | undefined,
) => {
  const summaryFieldId = roastingSummaryFieldIdExp(" | ");
  const org_values = getInputValuesCheck(form, formMemo, dataFunction, undefined, summaryFieldId, true);
  // Debug("org_values : ", org_values ? { ...org_values } : undefined);
  const org = getSummaryValues(
    t,
    { field: "roasting_org_summary", fieldId: { ...summaryFieldId }, valueJoin: "" },
    undefined,
    org_values,
    locale,
    true,
  );
  runFormFunction(formFunction, "roasting_summary", "setValue", org);
  const setValues: Record<string, any> = {};
  const compareId = id ?? form?.getFieldValue("roasting_compare_select");
  const compareData =
    formMemo &&
    compareId &&
    formMemo["timeline_chart"] &&
    formMemo["timeline_chart"].tempData &&
    formMemo["timeline_chart"].tempData[compareId]
      ? formMemo["timeline_chart"].tempData[compareId]
      : undefined;
  if (compareData) {
    const diffFieldIdList = roastingSummaryFieldIdExp(true);
    const diffFields = Object.keys(diffFieldIdList);
    const diffFieldId: Record<string, DataInputCommonParams> = {};
    diffFields.forEach((field) => {
      org_values[field + "_check"] = compareData.data[field];
      diffFieldId[field + "_diff"] = {
        ...diffFieldIdList[field],
        calcValueProp: { input1: field, mode: "-", input2: field + "_check" },
        sign: true,
      };
    });
    const diff = getSummaryValues(
      t,
      { field: "roasting_compare_diff", fieldId: { ...diffFieldId }, valueJoin: "" },
      undefined,
      org_values,
      locale,
      true,
    );
    runFormFunction(formFunction, "roasting_compare_diff", "setValue", diff);
    if (id) {
      const compare = getSummaryValues(
        t,
        { field: "roasting_compare_summary", fieldId: { ...summaryFieldId }, valueJoin: "" },
        undefined,
        compareData.data,
        locale,
        true,
      );
      runFormFunction(formFunction, "roasting_compare_summary", "setValue", compare);
      setValues.roasting_compare_memo = compareData.data.roasting_result_memo;
      // if (!roasting_compare_chart.includes(id)) {
      //   setValues.roasting_compare_chart = [...roasting_compare_chart, id];
      // }
      // if (!compareData.compare) {
      //   compareData.compare = true;
      //   setValues.timeline_chart = true;
      // }
    }
  }
  const roasting_compare_chart: string[] = form?.getFieldValue("roasting_compare_chart") ?? [];
  const roasting_compare_select = form?.getFieldValue("roasting_compare_select");
  if (formMemo && formMemo["timeline_chart"] && formMemo["timeline_chart"].tempData) {
    Object.keys(formMemo["timeline_chart"].tempData).forEach((tempid) => {
      const check = tempid === id || tempid === roasting_compare_select || roasting_compare_chart.includes(tempid);
      if (formMemo["timeline_chart"].tempData[tempid].compare !== check) {
        formMemo["timeline_chart"].tempData[tempid].compare = check;
        setValues.timeline_chart = true;
      }
    });
  }
  if (Object.keys(setValues).length > 0) {
    form?.setFieldsValue(setValues);
  }
};
const predictCheck = (
  form: FormInstance<any> | undefined,
  formFunction: Record<string, Record<string, Function>> | undefined,
  formMemo: Record<string, any> | undefined,
  dataFunction: Record<string, Function> | undefined,
) => {
  if (form?.getFieldValue("roasting_end_term") === undefined) {
    const series = getRoastingSeriesInput(form, formMemo, dataFunction);
    const pastProfiles: PastProfile[] = [];
    const pastRoastingSeries: RoastingSeries[] = [];
    if (formMemo && formMemo["timeline_chart"]) {
      if (!formMemo["timeline_chart"].predictHistory) {
        formMemo["timeline_chart"].predictHistory = {} as Record<number, PredictRealtimeDropResult>;
      }
      const tempData = formMemo["timeline_chart"].tempData;
      if (tempData) {
        Object.keys(tempData).forEach((id) => {
          const temp = tempData[id];
          if (temp.roastingSeries) {
            pastRoastingSeries.push(temp.roastingSeries);
          }
          if (temp.pastProfile) {
            pastProfiles.push(temp.pastProfile);
          }
        });
      }
    }
    const predictHistory: Record<number, PredictRealtimeDropResult> =
      formMemo && formMemo["timeline_chart"] && formMemo["timeline_chart"].predictHistory
        ? (formMemo["timeline_chart"].predictHistory as Record<number, PredictRealtimeDropResult>)
        : {};
    const targetLossValue = form?.getFieldValue("roasting_prediction_loss");
    const targetLoss = targetLossValue ? targetLossValue / 100 : undefined;
    const predict = predictRealtimeDrop({
      series,
      pastProfiles,
      pastRoastingSeries,
      predictHistory,
      targetLoss,
    });
    if (predict.currTime !== undefined && !isNaN(predict.currTime)) {
      predictHistory[predict.currTime] = predict;
    }
    if (form && predict) {
      const setValues: Record<string, any> = {};
      const roasting_prediction_change = form.getFieldValue("roasting_prediction_change");
      if (roasting_prediction_change && predict.closestSeries) {
        const closest_id = predict.closestSeries.seriesId;
        const compare_id = form.getFieldValue("roasting_compare_select");
        if (closest_id !== compare_id) {
          setValues.roasting_compare_select = closest_id;
          // form.setFieldValue("roasting_compare_select", closest_id);
        }
      }
      if (predict.remainingTime && predict.currTime) {
        setValues.roasting_prediction_term = dayjs((predict.remainingTime + predict.currTime) * 1000);
      }
      if (predict.predictedDropBT && predict.predictedDropBT > 0) {
        setValues.roasting_prediction_bean = Math.round(predict.predictedDropBT * 10) / 10;
      }
      if (!checkEmpty(setValues)) {
        form.setFieldsValue(setValues);
      }
    }
    Debug("predictRealtimeDrop : ", predict, predictHistory, targetLoss, series);
  }
};

export const roastingProfileCols = (
  form: RefObject<FormInstance<any> | undefined> | undefined,
  formFunction: Record<string, Record<string, Function>> | undefined,
  formMemo: Record<string, any> | undefined,
  dataFunction: Record<string, Function> | undefined,
  locale: string | undefined,
  setTimer: Function | undefined,
  t: TransitionType | undefined,
  message: MessageInstance | undefined,
  mobile: boolean | undefined,
): DataColumnRecord => {
  const onChangeChart = (e: any) => {
    predictCheck(form?.current, formFunction, formMemo, dataFunction);
    summaryRefresh(t, form?.current, formFunction, formMemo, dataFunction, locale);
    timelineChartChange(form?.current, e);
  };
  const getRoastingObj = (key: string, last: boolean) => {
    const result: DataColumnField = {
      indexKey: roastingIndexKeyStr,
      onChange: onChangeChart,
      itemClassName: (last ? dc.roastingProfileClassName : roastingProfileNextHidden) + " " + dc.roastingCheckItemClassName,
      labelClassName: dc.mobileHidden,
      read: { display: "notNull", displayCheckIds: [key + "_term", key + "_bean"] },
      valueClassName: "flex-col lg:flex-row mobile_multi",
    };
    result.fieldId = {};
    const checkMain: DataInputCommonParams = { flexClassName: "roasting_main" };
    checkMain.fieldId = {};
    checkMain.fieldId[key + "_term"] = { ...dc.roastingTerm, hiddenCheckValue: true };
    checkMain.fieldId[key + "_bean"] = { ...dc.roastingTemp, hiddenCheckValue: true };
    checkMain.fieldId[key + "_air"] = { ...dc.airTemp };

    const checkSub: DataInputCommonParams = { flexClassName: "ml-0 mt-2 lg:ml-2 lg:mt-0" };
    checkSub.fieldId = {};
    checkSub.fieldId[key + "_input1"] = dc.roastingInput1;
    checkSub.fieldId[key + "_input2"] = dc.roastingInput2;
    checkSub.fieldId[key + "_input3"] = dc.roastingInput3;

    result.fieldId[key + "_main"] = checkMain;
    result.fieldId[key + "_sub"] = checkSub;

    return result;
  };
  type CheckCommnd = "sort" | "up" | "down" | "insert" | "remove" | "clear" | "logcopy";
  const roastingCheckCommand = (cmd: CheckCommnd, index: number) => {
    const getFields: string[] = [];
    const fieldArr = cmd === "logcopy" ? ["_term", "_bean", "_air"] : checkFields;
    const nowArr: Record<string, any> = {};
    if (form?.current) {
      //먼저 값을 가져옴
      switch (cmd) {
        case "sort":
          for (let i = 1; i <= RoastingCheckCount; i++) {
            fieldArr.forEach((field) => getFields.push("roasting_check" + i + field));
            nowArr[i + ""] =
              formMemo && formMemo["roasting_check" + i + "_term"] ? formMemo["roasting_check" + i + "_term"].now : undefined;
          }
          break;
        case "up":
          for (let i = index - 1; i <= index; i++) {
            fieldArr.forEach((field) => getFields.push("roasting_check" + i + field));
            nowArr[i + ""] =
              formMemo && formMemo["roasting_check" + i + "_term"] ? formMemo["roasting_check" + i + "_term"].now : undefined;
          }
          break;
        case "down":
          Debug(cmd);
          for (let i = index; i <= index + 1; i++) {
            fieldArr.forEach((field) => getFields.push("roasting_check" + i + field));
            nowArr[i + ""] =
              formMemo && formMemo["roasting_check" + i + "_term"] ? formMemo["roasting_check" + i + "_term"].now : undefined;
          }
          break;
        case "insert":
          for (let i = index; i <= RoastingCheckCount; i++) {
            fieldArr.forEach((field) => getFields.push("roasting_check" + i + field));
            nowArr[i + ""] =
              formMemo && formMemo["roasting_check" + i + "_term"] ? formMemo["roasting_check" + i + "_term"].now : undefined;
          }
          break;
        case "remove":
          for (let i = index + 1; i <= RoastingCheckCount; i++) {
            fieldArr.forEach((field) => getFields.push("roasting_check" + i + field));
            nowArr[i + ""] =
              formMemo && formMemo["roasting_check" + i + "_term"] ? formMemo["roasting_check" + i + "_term"].now : undefined;
          }
          break;
        case "clear":
          break;
        case "logcopy":
          fieldArr.forEach((field) => getFields.push("timeline_chart_log" + field));
          break;
        default:
          break;
      }
      const getValues = getFields.length > 0 ? form.current.getFieldsValue(getFields) : {};
      //변경될 값들을 설정
      const setValues: Record<string, any> = {};
      switch (cmd) {
        case "sort":
          const termArr: { term: dayjs.Dayjs; index: number }[] = [];
          for (let i = 1; i <= RoastingCheckCount; i++) {
            const setNow = formMemo && formMemo["roasting_check" + i + "_term"] ? formMemo["roasting_check" + i + "_term"].now : undefined;
            termArr.push({ term: getValues["roasting_check" + i + "_term"], index: i });
          }
          termArr.sort((a, b) => (a.term && b.term ? a.term.valueOf() - b.term.valueOf() : a.term ? -1 : b.term ? 1 : 0));
          termArr.forEach((value, index) => {
            fieldArr.forEach((field) => {
              setValues["roasting_check" + (index + 1) + field] = getValues["roasting_check" + value.index + field];
            });
            runFormFunction(formFunction, "roasting_check" + (index + 1) + "_term", "setNow", nowArr[value.index + ""]);
          });
          break;
        case "up":
          fieldArr.forEach((field) => {
            setValues["roasting_check" + index + field] = getValues["roasting_check" + (index - 1) + field];
            runFormFunction(formFunction, "roasting_check" + index + "_term", "setNow", nowArr[index - 1 + ""]);
            setValues["roasting_check" + (index - 1) + field] = getValues["roasting_check" + index + field];
            runFormFunction(formFunction, "roasting_check" + (index - 1) + "_term", "setNow", nowArr[index + ""]);
          });
          break;
        case "down":
          fieldArr.forEach((field) => {
            setValues["roasting_check" + index + field] = getValues["roasting_check" + (index + 1) + field];
            runFormFunction(formFunction, "roasting_check" + index + "_term", "setNow", nowArr[index + 1 + ""]);
            setValues["roasting_check" + (index + 1) + field] = getValues["roasting_check" + index + field];
            runFormFunction(formFunction, "roasting_check" + (index + 1) + "_term", "setNow", nowArr[index + ""]);
          });
          break;
        case "insert":
          fieldArr.forEach((field) => {
            setValues["roasting_check" + index + field] = undefined;
            runFormFunction(formFunction, "roasting_check" + index + "_term", "setNow", undefined);
            for (let i = index; i < RoastingCheckCount; i++) {
              setValues["roasting_check" + (i + 1) + field] = getValues["roasting_check" + i + field];
              runFormFunction(formFunction, "roasting_check" + (i + 1) + "_term", "setNow", nowArr[i + ""]);
            }
          });
          break;
        case "remove":
          fieldArr.forEach((field) => {
            for (let i = index + 1; i < RoastingCheckCount; i++) {
              setValues["roasting_check" + (i - 1) + field] = getValues["roasting_check" + i + field];
              runFormFunction(formFunction, "roasting_check" + (i - 1) + "_term", "setNow", nowArr[i + ""]);
            }
            setValues["roasting_check" + RoastingCheckCount + field] = undefined;
            runFormFunction(formFunction, "roasting_check" + RoastingCheckCount + "_term", "setNow", undefined);
          });
          //
          break;
        case "clear":
          fieldArr.forEach((field) => {
            setValues["roasting_check" + index + field] = undefined;
          });
          runFormFunction(formFunction, "roasting_check" + index + "_term", "setNow", undefined);
          break;
        case "logcopy":
          fieldArr.forEach((field) => {
            setValues["roasting_check" + index + field] = getValues["timeline_chart_log" + field];
          });
          break;
        default:
          break;
      }
      Debug(cmd, getFields, getValues);
      Debug(setValues);
      form.current.setFieldsValue(setValues);
    }
  };
  const getRoastingCheckArr = (start: number, last: number): DataColumnRecord => {
    const result: DataColumnRecord = {};
    getIntArray(last, start).map((i) => {
      const key = "roasting_check" + i;
      const checkObj = getRoastingObj(key, i === last);
      if (checkObj.fieldId && checkObj.fieldId instanceof Object) {
        const checkBtn: DataInputCommonParams = {
          flexClassName: "ml-0 mt-2 lg:ml-2 lg:mt-0 roasting_check_btns",
          read: { display: false },
        };
        checkBtn.fieldId = {};
        checkBtn.fieldId[key + "_move_up"] = {
          ...dc.buttonDefault(
            "CaretUp",
            () => {
              roastingCheckCommand("up", i);
            },
            "default",
            undefined,
            "px-2",
            undefined,
            undefined,
            start === i,
          ),
          tooltip: "up_label",
        };
        checkBtn.fieldId[key + "_move_down"] = {
          ...dc.buttonDefault(
            "CaretDown",
            () => {
              roastingCheckCommand("down", i);
            },
            "default",
            undefined,
            "ml-2 px-2",
            undefined,
            undefined,
            last === i,
          ),
          tooltip: "down_label",
        };
        checkBtn.fieldId[key + "_insert"] = {
          ...dc.buttonDefault(
            "Plus",
            () => {
              roastingCheckCommand("insert", i);
            },
            "default",
            undefined,
            "ml-2 px-2",
            undefined,
            undefined,
            last === i,
          ),
          tooltip: "add_label",
        };
        checkBtn.fieldId[key + "_remove"] = {
          ...dc.buttonDefault(
            "Minus",
            () => {
              roastingCheckCommand("remove", i);
            },
            "default",
            undefined,
            "ml-2 px-2",
          ),
          tooltip: "remove_label",
        };
        checkBtn.fieldId[key + "_logcopy"] = {
          ...dc.buttonDefault(
            "NotePencil",
            () => {
              roastingCheckCommand("logcopy", i);
            },
            "default",
            undefined,
            "ml-2 px-2",
          ),
          tooltip: "logcopy_label",
        };
        checkBtn.fieldId[key + "_clear"] = {
          ...dc.buttonDefault(
            "Backspace",
            () => {
              roastingCheckCommand("clear", i);
            },
            "default",
            undefined,
            "ml-2 px-2",
          ),
          tooltip: "clear",
        };
        checkObj.fieldId[key + "_btn"] = checkBtn;
      }
      result[key] = checkObj;
    });
    return result;
  };
  // const getRoastingShowTimeObject = (key: string) => {
  //   return { bean: key + "_bean", air: key + "_air" };
  // };
  const getTimelineProp = (yScale: number): TimeLineProps => {
    const rorTerm = 20;
    const rorTermUnit = 60;
    return {
      fixed: true,
      beforeTime: ["pre_heating_start_term", "pre_heating_end_term"],
      showTimes: {
        ...getRoastingShowTimeCheck(1, RoastingCheckCount),
      },
      checkIds: ["bean", "air", "beansub", "beanror"],
      checkTimes: [
        "pre_heating_start_term",
        "pre_heating_end_term",
        "roasting_start_time",
        "roasting_turning_term",
        "roasting_dried_term",
        "roasting_first_start_term",
        "roasting_first_end_term",
        "roasting_second_start_term",
        "roasting_second_end_term",
        "roasting_end_term",
      ],
      checkValues: ["roasting_turning_term_", "roasting_dried_term"],
      compareBaseTime: "roasting_compare_point",
      compareBaseTimeInput: "roasting_compare_point_direct",
      hintIds: ["bean_compare1", "air_compare1", "beansub1", "beanror1"],
      dataOperation: {
        bean: { id: "beansub", title: "beansub", operation: "SUB", dataA: "air", dataB: "bean", unit: "°C", scale: 1, toFixed: 1 },
        bean_compare1: {
          id: "beansub1",
          title: "beansub1",
          compareStr: "_compare1",
          operation: "SUB",
          dataA: "air_compare1",
          dataB: "bean_compare1",
          unit: "°C",
          scale: 1,
          toFixed: 2,
        },
      },
      ror: {
        bean: {
          rorSeries: "bean",
          rorId: "beanror",
          rorTitle: "beanror",
          startId: "roasting_turning_term",
          endId: "roasting_end_term",
          rorTerm: rorTerm,
          rorTermUnit: rorTermUnit,
          rorScale: 3,
          toFixed: 2,
        },
        bean_compare1: {
          rorSeries: "bean_compare1",
          rorId: "beanror1",
          rorTitle: "beanror1",
          compareStr: "_compare1",
          startId: "roasting_turning_term",
          endId: "roasting_end_term",
          rorTerm: rorTerm,
          rorTermUnit: rorTermUnit,
          rorScale: 3,
          toFixed: 2,
        },
        bean_compare2: {
          rorSeries: "bean_compare2",
          rorId: "beanror2",
          rorTitle: "beanror2",
          compareStr: "_compare2",
          startId: "roasting_turning_term",
          endId: "roasting_end_term",
          rorTerm: rorTerm,
          rorTermUnit: rorTermUnit,
          rorScale: 3,
          toFixed: 2,
        },
        bean_compare3: {
          rorSeries: "bean_compare3",
          rorId: "beanror3",
          rorTitle: "beanror3",
          compareStr: "_compare3",
          startId: "roasting_turning_term",
          endId: "roasting_end_term",
          rorTerm: rorTerm,
          rorTermUnit: rorTermUnit,
          rorScale: 3,
          toFixed: 2,
        },
      },
      // colorMap: { bean: "var(--brown-9)", air: "var(--crimson-8)" },
      colorMap: {
        bean: { color: "#cea37e", width: 2 },
        air: { color: "#e2005bc2", width: 2 },
        beansub: { color: "#ffd148cc", width: 2 },
        beansub1: { color: "#ffd14877", width: 2, dashArray: "4 3" },
        beanror: { color: "#3377ffaa", width: 2 },
        beanror1: { color: "#3377ff77", width: 1.5, dashArray: "2 1" },
        beanror2: { color: "#3377ff77", width: 1.5, dashArray: "2 1" },
        beanror3: { color: "#3377ff77", width: 1.5, dashArray: "2 1" },
        bean_compare1: { color: "#a34e0060", width: 1.5, dashArray: "8 6" },
        air_compare1: { color: "#bf004753", width: 1.5, dashArray: "8 6" },
        bean_compare2: { color: "#a34e0060", width: 1.5, dashArray: "8 6" },
        air_compare2: { color: "#bf004753", width: 1.5, dashArray: "8 6" },
        bean_compare3: { color: "#a34e0060", width: 1.5, dashArray: "8 6" },
        air_compare3: { color: "#bf004753", width: 1.5, dashArray: "8 6" },
        bean_compare4: { color: "#a34e0060", width: 1.5, dashArray: "8 6" },
        air_compare4: { color: "#bf004753", width: 1.5, dashArray: "8 6" },
        bean_compare5: { color: "#a34e0060", width: 1.5, dashArray: "8 6" },
        air_compare5: { color: "#bf004753", width: 1.5, dashArray: "8 6" },
        bean_compare6: { color: "#a34e0060", width: 1.5, dashArray: "8 6" },
        air_compare6: { color: "#bf004753", width: 1.5, dashArray: "8 6" },
        bean_compare7: { color: "#a34e0060", width: 1.5, dashArray: "8 6" },
        air_compare7: { color: "#bf004753", width: 1.5, dashArray: "8 6" },
        bean_compare8: { color: "#a34e0060", width: 1.5, dashArray: "8 6" },
        air_compare8: { color: "#bf004753", width: 1.5, dashArray: "8 6" },
        bean_compare9: { color: "#a34e0060", width: 1.5, dashArray: "8 6" },
        air_compare9: { color: "#bf004753", width: 1.5, dashArray: "8 6" },
        bean_compare10: { color: "#a34e0060", width: 1.5, dashArray: "8 6" },
        air_compare10: { color: "#bf004753", width: 1.5, dashArray: "8 6" },
      },
      fill: dc.timelineFill({
        full: ["bean"],
        fill: [
          "air",
          "bean_compare1",
          "bean_compare2",
          "bean_compare3",
          "bean_compare4",
          "bean_compare5",
          "bean_compare6",
          "bean_compare7",
          "bean_compare8",
          "bean_compare9",
          "bean_compare10",
        ],
        half: [
          "beansub",
          "beanror",
          "air_compare1",
          "air_compare2",
          "air_compare3",
          "air_compare4",
          "air_compare5",
          "air_compare6",
          "air_compare7",
          "air_compare8",
          "air_compare9",
          "air_compare10",
        ],
      }),
      timerDelay: 1000,
      timerStart: () => {
        roastingTimerStart(form?.current, formFunction, { value: dayjs() }, true, setTimer);
      },
      timerStop: () => {
        if (form?.current?.getFieldValue("roasting_end_term")) {
          roastingTimerStop(form?.current, formFunction, { value: dayjs() }, true, setTimer);
        } else {
          runFormFunction(formFunction, "roasting_end_term", "setNowClick");
        }
      },
      timerClock: {
        onClick: () => {
          const checkValues = form?.current?.getFieldsValue([roastingIndexKeyStr, ...clock_list.map((item) => item + "_term")]);
          Debug(checkValues);
          if (!checkEmpty(checkValues[roastingIndexKeyStr])) {
            const check = clock_list.find((item) => checkEmpty(checkValues[item + "_term"]));
            if (check) {
              runFormFunction(formFunction, check + "_term", "setNowClick");
              focusFormField(form?.current, check + "_bean");
            }
          }
        },
      },
      timerCheck: {
        onClick: () => {
          const checkList = getIntArray(RoastingCheckCount, 1).map((i) => {
            return "roasting_check" + i;
          });
          const checkValues = form?.current?.getFieldsValue([...checkList.map((item) => item + "_term")]);
          if (!checkEmpty(checkValues)) {
            const check = checkList.find((item) => checkEmpty(checkValues[item + "_term"]));
            if (check) {
              runFormFunction(formFunction, check + "_term", "setNowClick");
              focusFormField(form?.current, check + "_bean");
            }
          }
        },
      },
      timerFind: {
        onClick: () => {
          const checkList = getIntArray(RoastingCheckCount, 1).map((i) => {
            return "roasting_check" + i;
          });
          const checkValues = form?.current?.getFieldsValue([
            roastingIndexKeyStr,
            ...clock_list.map((item) => item + "_term"),
            ...checkList.map((item) => item + "_term"),
          ]);
          if (!checkEmpty(checkValues[roastingIndexKeyStr])) {
            const nowTimer = dayjs().diff(checkValues[roastingIndexKeyStr]);
            Debug(nowTimer, checkValues);
            const check: { key: string; diff: number } = { key: roastingIndexKeyStr, diff: nowTimer };
            Object.keys(checkValues).forEach((item) => {
              if (item !== roastingIndexKeyStr && !checkEmpty(checkValues[item])) {
                const diff = Math.abs(nowTimer - dayjs(checkValues[item]).valueOf() - utcOffset);
                if (diff < check.diff) {
                  check.key = item;
                  check.diff = diff;
                }
              }
            });
            if (check.key !== roastingIndexKeyStr) {
              const target = check.key.substring(0, check.key.length - 4);
              focusFormField(form?.current, target + "bean");
            }
          }
        },
      },
      xFloorScale: 60000,
      xFloorConst: 30000,
      yFloorScale: yScale,
      yUnit: "°C",
      yViewScale: 100,
      yGridCount: mobile ? 4 : 6,
      min: { x: new Date(0), y: 150 },
      max: { x: new Date(180000), y: 175 },
      beforeId: "roasting_before",
      logId: "roasting_chart_log",
      onClick: (point: any) => {
        const xpoint = dayjs(point.points[0].data.x).valueOf();
        const log =
          getJsonFromStr(form?.current?.getFieldValue("roasting_chart_log")) ??
          (formMemo && formMemo && formMemo["timeline_chart"] ? formMemo["timeline_chart"].log : undefined);
        if (xpoint && log) {
          const log_data = log[xpoint];
          if (log_data) {
            const log_term = dayjs(xpoint).add(-utcOffset);
            if (form?.current) {
              const setValues: Record<string, any> = {
                timeline_chart_log_term: log_term,
                timeline_chart_log_bean: log_data.bean,
                timeline_chart_log_air: log_data.air,
              };
              const org_log_term = form.current.getFieldValue("timeline_chart_log_term");
              if (!checkEmpty(org_log_term)) {
                setValues.timeline_chart_log_term_end = org_log_term;
              }
              form.current.setFieldsValue(setValues);
              focusFormField(form.current, "timeline_chart_log_bean");
              //form.current.getFieldInstance("timeline_chart_log_bean");
            }
          }
        }
      },
    };
  };

  return {
    roasting_file_text: {
      label: "blank",
      inputType: "display",
      itemClassName: dc.roastingProfileClassName + " font-bold whitespace-pre-wrap",
      fixedValue: "roasting_file_text",
      read: { fixedValue: "roasting_file_text_read" },
      transition: true,
    },
    roasting_file: {
      labelClassName: dc.strongLabelClassName,
      inputType: "upload",
      itemClassName: dc.roastingProfileClassName,
      read: { display: false },
      // userType: ["SADMIN", "ADMIN", "TESTER", "PAID"],
      uploadProp: {
        maxCount: 1,
        beforeUpload: (file) => {
          Debug(file.type, file);
          const checkType = ["text/csv", "application/json", ""].some((item) => {
            if (!checkEmpty(file.type)) {
              return item === file.type;
            } else {
              Debug(file.name, file.name.indexOf(".alog"));
              return file.name.indexOf(".alog") > 0;
            }
          });
          if (!checkType && t) {
            Debug(t("not_checked_file_label"));
            message ? message.error(t("not_checked_file_label"), 5) : undefined;
          } else {
            if (t && message) {
              if (file.type === "application/json") {
                message.info(t("underconstruction_text"), 5);
              } else {
                message.success(t("roastingfile_upload_label"), 5);
              }
            }
            const data = file.text().then((value) => {
              convertProfiletoForm(form, file.type, value);
              onChangeChart(true);
              return value;
            });
          }
          // Debug(Upload.LIST_IGNORE);
          return checkType || Upload.LIST_IGNORE;
        },
        // previewFile(file) {
        //   return new Promise(() => {}).then();
        // },
      },
    },
    compare_file: {
      inputType: "upload",
      itemClassName: dc.roastingProfileClassName,
      // read: { display: false },
      // userType: ["SADMIN", "ADMIN", "TESTER", "PAID"],
      uploadProp: {
        maxCount: 1,
        beforeUpload: (file) => {
          Debug(file.type, file);
          const checkType = ["text/csv", "application/json", ""].some((item) => {
            if (!checkEmpty(file.type)) {
              return item === file.type;
            } else {
              Debug(file.name, file.name.indexOf(".alog"));
              return file.name.indexOf(".alog") > 0;
            }
          });
          if (!checkType && t) {
            Debug(t("not_checked_file_label"));
            message ? message.error(t("not_checked_file_label"), 5) : undefined;
          } else {
            if (t && message) {
              if (file.type === "application/json") {
                message.info(t("underconstruction_text"), 5);
              } else {
                message.success(t("roastingfile_upload_label"), 5);
              }
            }
            const data = file.text().then((value) => {
              const compareValue = convertProfiletoForm(form, file.type, value, true);
              Debug(compareValue);
              updateCompareProfile(form?.current, formFunction, formMemo, dataFunction, locale, "file_id", "File", compareValue);
              // onChangeChart(true);
              return value;
            });
          }
          // Debug(Upload.LIST_IGNORE);
          return checkType || Upload.LIST_IGNORE;
        },
        // previewFile(file) {
        //   return new Promise(() => {}).then();
        // },
      },
    },

    timeline_chart: {
      itemClassName: dc.roastingProfileClassName,
      ...dc.timelineChart,
      timelineProp: getTimelineProp(25),
      read: { timelineProp: getTimelineProp(mobile ? 25 : 10) },
      imageDownload: "RoastingProfile",
      indexKey: roastingIndexKeyStr,
      indexLabelKey: locale === koLocale ? "country_name" : "country_nick",
    },
    roasting_chart_option: {
      label: "blank",
      itemClassName: "roasting_profile_item",
      // labelUse: false,
      // valueStyle: { gridColumn: "1 / span 2" },
      fieldId: {
        roasting_before: {
          ...dc.use,
          // read: {
          //   display: "notNull",
          //   displayCheckIds: ["pre_heating_start", "pre_heating_end"],
          //   inputClassName: dc.use.read?.inputClassName,
          // },
          transition: true,
          switchProp: { checkedChildren: "pre_heating_label", unCheckedChildren: "pre_heating_label" },
          // read: { display: false },
          onChange: (e) => {
            setTimeout(() => {
              onChangeChart(e);
            }, dc.setTimeoutShort);
          },
          defaultValue: false,
          disabled: false,
          readInputDisabled: false,
          noItem: false,
        },
        roasting_check_show: {
          ...dc.use,
          transition: true,
          switchProp: { checkedChildren: "roasting_check", unCheckedChildren: "roasting_check" },
          // read: { display: false },
          onChange: (e) => {
            setFormClass(dataFunction, { hidden_roasting_check: !e.value });
          },
          defaultValue: true,
          read: {
            defaultValue: false,
            inputClassName: dc.use.inputClassName,
            display: "notNull",
            displayCheckIds: [
              ...getIntArray(RoastingCheckCount, 1).map((i) => {
                return "roasting_check" + i + "_term";
              }),
            ],
          },
          disabled: false,
          readInputDisabled: false,
          noItem: false,
          saveData: false,
        },
      },
    },
    roasting_info_text: {
      label: "blank",
      inputType: "display",
      itemClassName: dc.roastingProfileClassName + " font-bold whitespace-pre-wrap",
      fixedValue: "roasting_info_text",
      read: { display: false },
      transition: true,
    },
    roasting_explain: {
      itemClassName: dc.roastingProfileClassName,
      label: "blank",
      labelClassName: dc.mobileHidden,
      valueClassName: "flex-col lg:flex-row mobile_multi",
      fieldId: {
        roasting_explain_main: {
          flexClassName: "roasting_main",
          fieldId: {
            roasting_explain_term: {
              ...dc.roastingTerm,
              timeProp: { ...dc.roastingTerm.timeProp, nowButton: true, nowButtonClassName: "invisible" },
              read: { timeProp: { ...dc.roastingTerm.timeProp, nowButton: false } },
              disabled: true,
              readOnly: true,
              variant: "borderless",
              unit: "",
              noItem: true,
            },
            roasting_explain_bean: {
              ...dc.roastingTemp,
              disabled: true,
              readOnly: true,
              variant: "borderless",
              unit: "",
              noItem: true,
            },
            roasting_explain_air: {
              ...dc.airTemp,
              disabled: true,
              readOnly: true,
              variant: "borderless",
              unit: "",
              noItem: true,
            },
          },
        },
        roasting_explain_sub: {
          flexClassName: " ml-2 hidden lg:flex",
          fieldId: {
            roasting_explain_input1: {
              ...dc.roastingInput1,
              disabled: true,
              variant: "borderless",
              noItem: true,
            },
          },
        },
      },
    },
    div_roasting_0: {
      ...dc.itemDiv,
      itemClassName: dc.itemDiv.itemClassName + " " + dc.roastingProfileClassName,
      read: { display: "notNull", displayCheckIds: ["pre_heating_start", "pre_heating_end"] },
    },
    pre_heating_start: {
      onChange: onChangeChart,
      indexKey: roastingIndexKeyStr,
      itemClassName: roastingProfileNextHidden,
      read: { display: "notNull", displayCheckIds: ["pre_heating_start_term"] },
      valueClassName: "flex-col lg:flex-row mobile_multi",
      fieldId: {
        pre_heating_start_main: {
          flexClassName: "roasting_main",
          fieldId: {
            pre_heating_start_term: {
              ...dc.roastingTerm,
              timeProp: {
                ...dc.roastingTerm.timeProp,
                nowButtonClick: (e: any) => {
                  Debug("pre_heating_start_time", e);
                  if (setTimer && form?.current) {
                    const start_timer = form.current.getFieldValue(roastingIndexKeyStr);
                    if (e && e.value === undefined && (start_timer === null || start_timer === undefined)) {
                      if (form.current.getFieldValue(roasting_step_str) === "RSRV") {
                        form.current.setFieldValue(roasting_step_str, "RD");
                      }
                      setTimer({ timer: "pre_heating_start_time", start: dayjs() });
                    } else {
                      setTimer({ timer: "pre_heating_start_time", start: undefined });
                    }
                  }
                },
              },
              hiddenCheckValue: true,
            },
            pre_heating_start_bean: { ...dc.roastingTemp, hiddenCheckValue: true },
            pre_heating_start_air: dc.airTemp,
          },
        },
        pre_heating_start_sub: {
          flexClassName: "ml-0 mt-2 lg:ml-2 lg:mt-0",
          fieldId: {
            pre_heating_start_input1: dc.roastingInput1,
            pre_heating_start_input2: dc.roastingInput2,
            pre_heating_start_input3: dc.roastingInput3,
          },
        },
      },
    },
    pre_heating_end: {
      itemClassName: dc.roastingProfileClassName,
      onChange: onChangeChart,
      indexKey: roastingIndexKeyStr,
      read: { display: "notNull", displayCheckIds: ["pre_heating_end_term"] },
      valueClassName: "flex-col lg:flex-row mobile_multi",
      fieldId: {
        pre_heating_end_main: {
          flexClassName: "roasting_main",
          fieldId: {
            pre_heating_end_term: {
              ...dc.roastingTerm,
              timeProp: {
                ...dc.roastingTerm.timeProp,
                nowButtonClick: (e: any) => {
                  if (setTimer && form?.current) {
                    const start_timer = form.current.getFieldValue(roastingIndexKeyStr);
                    if (e && e.value === undefined && (start_timer === null || start_timer === undefined)) {
                      setTimer({ timer: "pre_heating_end_time", start: dayjs() });
                      if (form.current.getFieldValue(roasting_step_str) === "RSRV") {
                        form.current.setFieldValue(roasting_step_str, "RD");
                      }
                    } else {
                      setTimer({ timer: "pre_heating_end_time", start: undefined });
                    }
                  }
                },
              },
            },
            pre_heating_end_bean: dc.roastingTemp,
            pre_heating_end_air: dc.airTemp,
          },
        },
        pre_heating_end_sub: {
          flexClassName: "ml-0 mt-2 lg:ml-2 lg:mt-0",
          fieldId: {
            pre_heating_end_input1: dc.roastingInput1,
            pre_heating_end_input2: dc.roastingInput2,
            pre_heating_end_input3: dc.roastingInput3,
          },
        },
      },
    },
    div_roasting_1: { ...dc.itemDiv, itemClassName: dc.itemDiv.itemClassName + " " + dc.roastingProfileClassName },
    roasting_start: {
      labelClassName: dc.strongLabelClassName,
      indexKey: roastingIndexKeyStr,
      onChange: onChangeChart,
      valueClassName: "flex-col lg:flex-row mobile_multi",
      fieldId: {
        roasting_start_main: {
          flexClassName: "roasting_main",
          fieldId: {
            roasting_start_time: {
              ...dc.roastingTime,
              read: { dateFormatter: "A hh:mm:ss" },
              changePass: true,
              tooltip: true,
              tooltipPlacement: "leftTop",
              onChange: (e: any) => {
                roastingTimerStart(form?.current, formFunction, e, false, setTimer);
              },
            },
            roasting_start_bean: {
              ...dc.roastingTemp,
              inputClassName: dc.roastingTemp.inputClassName + " " + dc.roastingProfileClassName,
            },
            roasting_start_air: {
              ...dc.airTemp,
              inputClassName: dc.airTemp.inputClassName + " " + dc.roastingProfileClassName,
            },
          },
        },
        roasting_start_sub: {
          flexClassName: "ml-0 mt-2 lg:ml-2 lg:mt-0 " + dc.roastingProfileClassName,
          fieldId: {
            roasting_start_input1: dc.roastingInput1,
            roasting_start_input2: dc.roastingInput2,
            roasting_start_input3: dc.roastingInput3,
          },
        },
      },
    },
    roasting_turning: {
      indexKey: roastingIndexKeyStr,
      onChange: onChangeChart,
      itemClassName: roastingProfileNextHidden,
      valueClassName: "flex-col lg:flex-row mobile_multi",
      fieldId: {
        roasting_turning_main: {
          flexClassName: "roasting_main",
          fieldId: {
            roasting_turning_term: { ...dc.roastingTerm, hiddenCheckValue: true },
            roasting_turning_bean: { ...dc.roastingTemp, hiddenCheckValue: true },
            roasting_turning_air: dc.airTemp,
          },
        },
        roasting_turning_sub: {
          flexClassName: "ml-0 mt-2 lg:ml-2 lg:mt-0",
          fieldId: {
            roasting_turning_input1: dc.roastingInput1,
            roasting_turning_input2: dc.roastingInput2,
            roasting_turning_input3: dc.roastingInput3,
          },
        },
      },
    },
    roasting_dried: {
      indexKey: roastingIndexKeyStr,
      onChange: onChangeChart,
      itemClassName: dc.roastingProfileClassName,
      valueClassName: "flex-col lg:flex-row mobile_multi",
      fieldId: {
        roasting_dried_main: {
          flexClassName: "roasting_main",
          fieldId: {
            roasting_dried_term: { ...dc.roastingTerm, hiddenCheckValue: true },
            roasting_dried_bean: { ...dc.roastingTemp, hiddenCheckValue: true },
            roasting_dried_air: dc.airTemp,
          },
        },
        roasting_dried_sub: {
          flexClassName: "ml-0 mt-2 lg:ml-2 lg:mt-0",
          fieldId: {
            roasting_dried_input1: dc.roastingInput1,
            roasting_dried_input2: dc.roastingInput2,
            roasting_dried_input3: dc.roastingInput3,
          },
        },
      },
    },
    div_roasting_2: {
      ...dc.itemDiv,
      itemClassName: dc.itemDiv.itemClassName + " " + dc.roastingProfileClassName + " " + dc.roastingCheckItemClassName,
      read: { display: false },
    },
    roasting_check: {
      itemClassName: dc.roastingProfileClassName + " " + dc.roastingCheckItemClassName,
      valueClassName: "flex-col lg:flex-row mobile_multi",
      read: { display: false },
      fieldId: {
        roasting_check_main: {
          flexClassName: "roasting_main",
          fieldId: {
            // roasting_check_start: { ...dc.roastingTerm },
            roasting_check_sort: {
              ...dc.buttonDefault(
                "SortAscending",
                () => {
                  roastingCheckCommand("sort", 0);
                },
                "default",
                undefined,
                "px-2",
              ),
              tooltip: "sort_asc_label",
            },
            roasting_check_term: {
              ...dc.select,
              unit: "term_second",
              inputClassName: dc.roastingTimeButtonWidth,
              valueList: [
                { label: locale === "ko" ? "30초" : "30s", value: 30 },
                { label: locale === "ko" ? "1분" : "1m", value: 60 },
                { label: locale === "ko" ? "2분" : "2m", value: 120 },
              ],
              create: { defaultValue: 60 },
              noItem: false,
              saveData: false,
            },
            roasting_check_input: {
              ...dc.buttonDefault(
                "NotePencil",
                () => {
                  fillCheckValues(form?.current, true);
                },
                "default",
                undefined,
                "ml-2 px-2",
              ),
              tooltip: "check_input",
            },
            roasting_check_until: {
              ...dc.untilMinite,
              saveData: false,
              inputClassName: dc.inputNumberClassName,
            },
            roasting_check_clear: {
              ...dc.buttonDefault(
                "Trash",
                () => {
                  if (form?.current) {
                    const setValues: Record<string, any> = {};
                    for (let i = 1; i <= RoastingCheckCount; i++) {
                      checkFields.forEach((field) => {
                        setValues["roasting_check" + i + field] = undefined;
                      });
                    }
                    form.current.setFieldsValue(setValues);
                  }
                },
                "default",
                undefined,
                "ml-2 px-2",
              ),
              tooltip: "clear",
            },
            roasting_check_btns_use: {
              ...dc.useTextStr("button_label"),
              onChange: (e) => {
                setFormClass(dataFunction, { roasting_check_btns_use: e.value });
              },
              defaultValue: false,
            },
          },
        },
      },
      // ...dc.hidden,
      // itemClassName: "md:hidden",
      // valueClassName: "hidden",
    },
    div_roasting_2_1: {
      ...dc.itemDiv,
      itemClassName: dc.itemDiv.itemClassName + " " + dc.roastingProfileClassName + " " + dc.roastingCheckItemClassName,
      read: {
        display: "notNull",
        displayCheckIds: [
          ...getIntArray(RoastingCheckCount, 1).map((i) => {
            return "roasting_check" + i + "_term";
          }),
        ],
      },
    },
    ...getRoastingCheckArr(1, RoastingCheckCount),
    div_roasting_3: {
      ...dc.itemDiv,
      itemClassName: dc.itemDiv.itemClassName + " " + dc.roastingProfileClassName + " " + dc.roastingCheckItemClassName,
      read: { display: false },
    },
    roasting_chart_log: {
      ...dc.textArea,
      itemClassName: "hidden",
      maxLength: 100000,
      read: { display: false },
    },
    timeline_chart_time_shift: {
      label: "time_shift",
      itemClassName: dc.roastingProfileClassName + " " + dc.roastingCheckItemClassName,
      valueClassName: "flex-col lg:flex-row mobile_multi",
      read: { display: false },
      fieldId: {
        timeline_chart_time_shift_main: {
          fieldId: {
            timeline_chart_time_shift_term: {
              ...dc.number,
              unit: "s",
              inputClassName: dc.roastingTimeWidth,
              noItem: false,
              saveData: false,
            },
            timeline_chart_time_shift_input: {
              ...dc.buttonDefault(
                "CheckSquare",
                () => {
                  const check_form = form?.current;
                  if (check_form) {
                    const { timeline_chart_time_shift_type: shiftType, timeline_chart_time_shift_term: shiftTerm } =
                      check_form.getFieldsValue(["timeline_chart_time_shift_type", "timeline_chart_time_shift_term"]);

                    const shiftArr = checkEmpty(shiftType)
                      ? ["roasting_start_time"]
                      : shiftType !== "roasting_start_exclude"
                        ? [shiftType]
                        : [
                            "roasting_turning_term",
                            "roasting_dried_term",
                            "roasting_first_start_term",
                            "roasting_first_end_term",
                            "roasting_second_start_term",
                            "roasting_second_end_term",
                            "roasting_end_term",
                          ];
                    Debug(shiftType, shiftTerm, shiftArr);
                    const values = check_form.getFieldsValue(shiftArr);
                    const setValues: Record<string, any> = {};
                    if (checkEmpty(shiftType)) {
                      setValues["timeline_chart_time_shift_type"] = "roasting_start_time";
                    }
                    Object.keys(values).forEach((field) => {
                      setValues[field] =
                        field === "roasting_start_time" ? dayjs(values[field] - shiftTerm * 1000) : values[field] + shiftTerm * 1000;
                      if (field === "roasting_start_time") {
                        roastingTimerStart(form?.current, formFunction, { value: setValues[field] }, false, setTimer);
                      }
                    });
                    Debug(values, setValues);
                    check_form.setFieldsValue(setValues);
                  }
                },
                "default",
                undefined,
                "ml-2 px-2",
              ),
              tooltip: "check_input",
            },
            timeline_chart_time_shift_type: {
              ...dc.select,
              inputClassName: dc.inputNumberWidth,
              valueList: [
                { label: "roasting_start_time", value: "roasting_start_time" },
                { label: "roasting_start_exclude", value: "roasting_start_exclude" },
                { label: "roasting_turning_term", value: "roasting_turning_term" },
                { label: "roasting_dried_term", value: "roasting_dried_term" },
                { label: "roasting_first_start_term", value: "roasting_first_start_term" },
                { label: "roasting_first_end_term", value: "roasting_first_end_term" },
                { label: "roasting_second_start_term", value: "roasting_second_start_term" },
                { label: "roasting_second_end_term", value: "roasting_second_end_term" },
                { label: "roasting_end_term", value: "roasting_end_term" },
              ],
              transition: true,
              create: { defaultValue: "roasting_start" },
              noItem: false,
              saveData: false,
            },
          },
        },
      },
    },

    timeline_chart_log: {
      read: { display: false },
      itemClassName: dc.roastingProfileClassName + " " + dc.roastingCheckItemClassName,
      // labelClassName: "ButtonLabel",
      label: "log_edit",

      valueClassName: "flex-col lg:flex-row mobile_multi",
      fieldId: {
        timeline_chart_log_main: {
          flexClassName: "roasting_main",
          fieldId: {
            timeline_chart_log_term: {
              ...dc.roastingTerm,
              indexKey: roastingIndexKeyStr,
              saveData: false,
              onChange: (e) => {
                const log_term = Math.floor(dayjs(e.value).add(utcOffset).valueOf() / 1000) * 1000;
                if (formMemo) {
                  if (form?.current) {
                    const org_value = form.current.getFieldValue("timeline_chart_log_term");
                    // Debug("org_value", org_value);
                    const chart_log =
                      getJsonFromStr(form.current.getFieldValue("roasting_chart_log")) ??
                      (formMemo["timeline_chart"] ? formMemo["timeline_chart"].log : undefined);
                    try {
                      const setValues: Record<string, any> = {};
                      if (chart_log && chart_log[log_term.valueOf()]) {
                        const chart_log_data = chart_log[log_term];
                        setValues.timeline_chart_log_bean = chart_log_data.bean;
                        setValues.timeline_chart_log_air = chart_log_data.air;
                      } else {
                        setValues.timeline_chart_log_bean = undefined;
                        setValues.timeline_chart_log_air = undefined;
                      }
                      form.current.setFieldsValue(setValues);
                    } catch (e) {
                      Debug(e);
                    }
                  }
                }
              },
            },
            timeline_chart_log_bean: { ...dc.roastingTemp, saveData: false },
            timeline_chart_log_air: { ...dc.airTemp, saveData: false },
          },
        },
        timeline_chart_log_sub: {
          flexClassName: "ml-0 mt-2 lg:ml-2 lg:mt-0",
          fieldId: {
            timeline_chart_log_input: {
              ...dc.buttonDefault(
                "NotePencil",
                (e) => {
                  if (form?.current) {
                    const term = form.current.getFieldValue("timeline_chart_log_term");
                    const bean = form.current.getFieldValue("timeline_chart_log_bean");
                    const air = form.current.getFieldValue("timeline_chart_log_air");
                    if (term) {
                      const log_term = Math.floor(term.add(utcOffset).valueOf() / 1000) * 1000;
                      const log = getJsonFromStr(form.current.getFieldValue("roasting_chart_log")) ?? {};
                      if (log) {
                        log[log_term] = { bean, air };
                        Object.keys(log).forEach((key) => {
                          const temp_log = log[key];
                          if (checkEmpty(temp_log.bean) && checkEmpty(temp_log.air)) {
                            delete log[key];
                          }
                        });
                        if (!checkEmpty(log)) {
                          form.current.setFieldValue("roasting_chart_log", getStrFromJson(log));
                        } else {
                          form.current.setFieldValue("roasting_chart_log", undefined);
                        }
                      }
                      onChangeChart(e);
                      Debug(term.add(utcOffset).valueOf(), bean, air, log);
                    }
                  }
                },
                "default",
                undefined,
                "px-2",
              ),
              tooltip: "log_edit",
            },
            timeline_chart_log_check: {
              ...dc.buttonDefault(
                "CheckSquare",
                (e) => {
                  if (form?.current) {
                    const index = getLastCheckIndex(form?.current);
                    roastingCheckCommand("logcopy", index);
                  }
                },
                "default",
                undefined,
                "ml-2 px-2",
              ),
              tooltip: "log_check_input",
            },

            timeline_chart_log_clear: {
              ...dc.buttonDefault(
                "Backspace",
                () => {
                  if (form?.current) {
                    const term = form.current.getFieldValue("timeline_chart_log_term");
                    if (term) {
                      const log_term = Math.floor(term.add(utcOffset).valueOf() / 1000) * 1000;
                      const log = getJsonFromStr(form.current.getFieldValue("roasting_chart_log")) ?? {};
                      if (log) {
                        const setValues: Record<string, any> = {};
                        if (log[log_term]) {
                          delete log[log_term];
                          Debug("delete log term : " + log_term);
                        } else {
                          setValues.timeline_chart_log_term = undefined;
                          setValues.timeline_chart_log_bean = undefined;
                          setValues.timeline_chart_log_air = undefined;
                        }
                        setValues.roasting_chart_log = !checkEmpty(log) ? getStrFromJson(log) : undefined;
                        form.current.setFieldsValue(setValues);
                      }
                      onChangeChart(undefined);
                    }
                  }
                },
                "default",
                undefined,
                "ml-2 px-2",
              ),
              tooltip: "clear",
            },
          },
        },
      },
    },
    timeline_chart_log_editor: {
      label: "log_clear",
      labelClassName: dc.mobileHidden, // + " ButtonLabel",
      itemClassName: dc.roastingProfileClassName + " " + dc.roastingCheckItemClassName,
      read: { display: false },
      fieldId: {
        // log_clear:{
        //   element: "log_clear",
        //   elementType: "button",
        //   transition: true,
        //   buttonProp: {
        //     type: "default",
        //     className: dc.strongLabelClassName,
        //     onClick: (e: any) => {
        //       form?.current?.setFieldsValue({ roasting_chart_log: undefined, timeline_chart: true });
        //     },
        //   },
        // },
        //"blank",

        timeline_chart_log_term_end: {
          ...dc.roastingTerm,
          indexKey: roastingIndexKeyStr,
          saveData: false,
        },
        timeline_chart_log_term_input: {
          ...dc.buttonDefault(
            "NotePencil",
            (e) => {
              if (form?.current) {
                form.current.setFieldsValue({
                  timeline_chart_log_term_end: form.current.getFieldValue("timeline_chart_log_term"),
                  timeline_chart_log_term: undefined,
                });
              }
            },
            "default",
            undefined,
            "ml-2 px-2",
          ),
          tooltip: "log_edit",
        },
        timeline_chart_log_term_clear: {
          ...dc.buttonDefault(
            "Trash",
            () => {
              if (form?.current) {
                const term = form.current.getFieldsValue(["timeline_chart_log_term", "timeline_chart_log_term_end"]);
                Debug(term);
                if (term && !checkEmpty(term)) {
                  const termObj: { start: number | null; end: number | null } = { start: null, end: null };
                  if (
                    !checkEmpty(term.timeline_chart_log_term) &&
                    !checkEmpty(term.timeline_chart_log_term_end) &&
                    term.timeline_chart_log_term > term.timeline_chart_log_term_end
                  ) {
                    termObj.start = !checkEmpty(term.timeline_chart_log_term_end)
                      ? Math.floor(term.timeline_chart_log_term_end.add(utcOffset).valueOf() / 1000) * 1000
                      : term.timeline_chart_log_term_end;
                    termObj.end = !checkEmpty(term.timeline_chart_log_term)
                      ? Math.floor(term.timeline_chart_log_term.add(utcOffset).valueOf() / 1000) * 1000
                      : term.timeline_chart_log_term;
                  } else {
                    termObj.start = !checkEmpty(term.timeline_chart_log_term)
                      ? Math.floor(term.timeline_chart_log_term.add(utcOffset).valueOf() / 1000) * 1000
                      : term.timeline_chart_log_term;
                    termObj.end = !checkEmpty(term.timeline_chart_log_term_end)
                      ? Math.floor(term.timeline_chart_log_term_end.add(utcOffset).valueOf() / 1000) * 1000
                      : term.timeline_chart_log_term_end;
                  }
                  const log = getJsonFromStr(form.current.getFieldValue("roasting_chart_log")) ?? {};
                  Debug(termObj);
                  if (log) {
                    Object.keys(log).forEach((key) => {
                      const keyno = Number(key);
                      if (!isNaN(keyno)) {
                        if (termObj.start !== null && termObj.end !== null) {
                          if (keyno >= termObj.start && keyno <= termObj.end) {
                            delete log[key];
                          }
                        } else if (termObj.start !== null) {
                          if (keyno >= termObj.start) {
                            delete log[key];
                          }
                        } else if (termObj.end !== null) {
                          if (keyno <= termObj.end) {
                            delete log[key];
                          }
                        } else {
                          delete log[key];
                        }
                      }
                    });
                    const chart_log = !checkEmpty(log) ? getStrFromJson(log) : undefined;
                    form.current.setFieldsValue({
                      roasting_chart_log: chart_log,
                      // timeline_chart_log_bean: undefined,
                      // timeline_chart_log_air: undefined,
                    });
                  }
                  onChangeChart(undefined);
                }
              }
            },
            "default",
            undefined,
            "ml-2 px-2",
          ),
          tooltip: "clear",
        },
      },
    },
    timeline_chart_log_temp: {
      label: "log_temp",
      itemClassName: dc.roastingProfileClassName + " " + dc.roastingCheckItemClassName,
      valueClassName: "flex-col lg:flex-row mobile_multi",
      read: { display: false },
      fieldId: {
        timeline_chart_log_temp_main: {
          fieldId: {
            timeline_chart_log_temp_term: {
              ...dc.select,
              unit: "term_second",
              inputClassName: dc.roastingTimeButtonWidth,
              valueList: [
                { label: "10°C", value: 10 },
                { label: "5°C", value: 5 },
              ],
              create: { defaultValue: 10 },
              noItem: false,
              saveData: false,
            },
            timeline_chart_log_temp_input: {
              ...dc.buttonDefault(
                "NotePencil",
                () => {
                  logTempInputCheck(form?.current);
                },
                "default",
                undefined,
                "ml-2 px-2",
              ),
              tooltip: "check_input",
            },
          },
        },
      },
    },
    div_roasting_4: {
      ...dc.itemDiv,
      itemClassName: dc.itemDiv.itemClassName + " " + dc.roastingProfileClassName,
      read: { display: "notNull", displayCheckIds: ["roasting_first_start_term", "roasting_first_end_term"] },
    },
    roasting_first_start: {
      indexKey: roastingIndexKeyStr,
      onChange: onChangeChart,
      itemClassName: roastingProfileNextHidden,
      read: { display: "notNull", displayCheckIds: ["roasting_first_start_term"] },
      valueClassName: "flex-col lg:flex-row mobile_multi",
      fieldId: {
        roasting_first_start_main: {
          flexClassName: "roasting_main",
          fieldId: {
            roasting_first_start_term: {
              ...dc.roastingTerm,
              timeProp: {
                ...dc.roastingTerm.timeProp,
                nowButtonClick: (e: any) => {
                  if (setTimer && form?.current) {
                    const start_end_values = form.current.getFieldsValue([roastingIndexKeyStr, "roasting_end_term"]);
                    Debug("roasting_first_start_time", e, start_end_values);
                    if (
                      e &&
                      e.value !== undefined &&
                      start_end_values[roastingIndexKeyStr] &&
                      checkEmpty(start_end_values.roasting_end_term)
                    ) {
                      setTimer({ timer: "roasting_first_start_time", start: dayjs() });
                    }
                  }
                },
              },
              hiddenCheckValue: true,
            },
            roasting_first_start_bean: { ...dc.roastingTemp, hiddenCheckValue: true },
            roasting_first_start_air: dc.airTemp,
          },
        },
        roasting_first_start_sub: {
          flexClassName: "ml-0 mt-2 lg:ml-2 lg:mt-0",
          fieldId: {
            roasting_first_start_input1: dc.roastingInput1,
            roasting_first_start_input2: dc.roastingInput2,
            roasting_first_start_input3: dc.roastingInput3,
          },
        },
      },
    },
    roasting_first_end: {
      indexKey: roastingIndexKeyStr,
      onChange: onChangeChart,
      itemClassName: dc.roastingProfileClassName,
      read: { display: "notNull", displayCheckIds: ["roasting_first_end_term"] },
      valueClassName: "flex-col lg:flex-row mobile_multi",
      fieldId: {
        roasting_first_end_main: {
          flexClassName: "roasting_main",
          fieldId: {
            roasting_first_end_term: { ...dc.roastingTerm, hiddenCheckValue: true },
            roasting_first_end_bean: { ...dc.roastingTemp, hiddenCheckValue: true },
            roasting_first_end_air: dc.airTemp,
          },
        },
        roasting_first_end_sub: {
          flexClassName: "ml-0 mt-2 lg:ml-2 lg:mt-0",
          fieldId: {
            roasting_first_end_input1: dc.roastingInput1,
            roasting_first_end_input2: dc.roastingInput2,
            roasting_first_end_input3: dc.roastingInput3,
          },
        },
      },
    },
    div_roasting_5: {
      ...dc.itemDiv,
      itemClassName: dc.itemDiv.itemClassName + " " + dc.roastingProfileClassName,
      read: { display: "notNull", displayCheckIds: ["roasting_second_start_term", "roasting_second_end_term"] },
    },
    roasting_second_start: {
      indexKey: roastingIndexKeyStr,
      onChange: onChangeChart,
      itemClassName: roastingProfileNextHidden,
      read: { display: "notNull", displayCheckIds: ["roasting_second_start_term"] },
      valueClassName: "flex-col lg:flex-row mobile_multi",
      fieldId: {
        roasting_second_start_main: {
          flexClassName: "roasting_main",
          fieldId: {
            roasting_second_start_term: {
              ...dc.roastingTerm,
              timeProp: {
                ...dc.roastingTerm.timeProp,
                nowButtonClick: (e: any) => {
                  Debug("roasting_second_start_time", e);
                  if (setTimer && form?.current) {
                    const start_end_values = form.current.getFieldsValue([roastingIndexKeyStr, "roasting_end_term"]);
                    if (
                      e &&
                      e.value !== undefined &&
                      start_end_values[roastingIndexKeyStr] &&
                      checkEmpty(start_end_values.roasting_end_term)
                    ) {
                      setTimer({ timer: "roasting_second_start_time", start: dayjs() });
                    }
                  }
                },
              },
              hiddenCheckValue: true,
            },
            roasting_second_start_bean: { ...dc.roastingTemp, hiddenCheckValue: true },
            roasting_second_start_air: dc.airTemp,
          },
        },
        roasting_second_start_sub: {
          flexClassName: "ml-0 mt-2 lg:ml-2 lg:mt-0",
          fieldId: {
            roasting_second_start_input1: dc.roastingInput1,
            roasting_second_start_input2: dc.roastingInput2,
            roasting_second_start_input3: dc.roastingInput3,
          },
        },
      },
    },
    roasting_second_end: {
      indexKey: roastingIndexKeyStr,
      onChange: onChangeChart,
      read: { display: "notNull", displayCheckIds: ["roasting_second_end_term"] },
      itemClassName: dc.roastingProfileClassName,
      valueClassName: "flex-col lg:flex-row mobile_multi",
      fieldId: {
        roasting_second_end_main: {
          flexClassName: "roasting_main",
          fieldId: {
            roasting_second_end_term: dc.roastingTerm,
            roasting_second_end_bean: dc.roastingTemp,
            roasting_second_end_air: dc.airTemp,
          },
        },
        roasting_second_end_sub: {
          flexClassName: "ml-0 mt-2 lg:ml-2 lg:mt-0",
          fieldId: {
            roasting_second_end_input1: dc.roastingInput1,
            roasting_second_end_input2: dc.roastingInput2,
            roasting_second_end_input3: dc.roastingInput3,
          },
        },
      },
    },
    div_roasting_6: { ...dc.itemDiv, itemClassName: dc.itemDiv.itemClassName + " " + dc.roastingProfileClassName },
    roasting_end: {
      indexKey: roastingIndexKeyStr,
      onChange: onChangeChart,
      // read: { display: "notNull", displayCheckIds: ["roasting_end_term"] },
      itemClassName: "next-hidden-show",
      labelClassName: dc.strongLabelClassName,
      valueClassName: "flex-col lg:flex-row mobile_multi",
      fieldId: {
        roasting_end_main: {
          flexClassName: "roasting_main",
          fieldId: {
            roasting_end_term: {
              ...dc.roastingTerm,
              changePass: true,
              onChange: (e: any) => {
                roastingTimerStop(form?.current, formFunction, e, false, setTimer);
              },
            },
            roasting_end_bean: {
              ...dc.roastingTemp,
              inputClassName: dc.roastingTemp.inputClassName + " " + dc.roastingProfileClassName,
            },
            roasting_end_air: {
              ...dc.airTemp,
              inputClassName: dc.airTemp.inputClassName + " " + dc.roastingProfileClassName,
            },
          },
        },
        roasting_end_sub: {
          flexClassName: "ml-0 mt-2 lg:ml-2 lg:mt-0 " + dc.roastingProfileClassName,
          fieldId: {
            roasting_end_input1: dc.roastingInput1,
            roasting_end_input2: dc.roastingInput2,
            roasting_end_input3: dc.roastingInput3,
          },
        },
      },
    },
  };
};
